<div class="card">
  <div class="card-header">
    <span class="card-title">Hold Point Inspection</span>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-7">
        <comments-box
          [formType]="data.formType"
          [serialNo]="serialNo"
          [minHeight]="'200px'"
          [title]="'Hold Point Inspection Description'"
          [textValue]="data.holdPoint.description"
          (textChanged)="textChanged($event)"
          [hasError]="!hasDescription()"
          [noSubscript]="hasDescription()"
        >
        </comments-box>
      </div>
      <div class="col-5 d-flex flex-column justify-content-between">
        <div *ngFor="let wfTaskLocal of wfTaskLocals">
          <mat-checkbox color="accent" [(ngModel)]="wfTaskLocal.required"
            ><span class="d-flex align-items-center"
              >{{ wfTaskLocal.name }}
              <role-chips
                class="ml-2"
                [roleCodes]="getRoles(wfTaskLocal)"
                [userNames]="getUserName(wfTaskLocal)"
              ></role-chips
            ></span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-flat-button class="cancel-btn" color="warn" (click)="cancel()">
        Cancel
      </button>
      <button mat-flat-button class="accept-btn" color="primary" [disabled]="!isValid()" (click)="save()">
        Save
      </button>
    </div>
  </div>
</div>
